import {Routes, Route } from 'react-router-dom';
import Login from './Authentication/Login';
import RegisterSubscription from './Authentication/RegisterSubscription';
import Dashboard from './Components/Admin/Dashboard';
import Lenders from './Components/Master/Lenders';
import Register from './Authentication/Register';
import ChangePassword from './Components/ChangePassword';
import Logout from './Authentication/Logout';
import LendingApplications from './Components/Admin/LendingApplications';
import Industry from './Components/Master/Industry';
import LendingApplication from './Components/Admin/LendingApplication';
import UploadApplication from './Components/Clients/UploadApplication';
import ClientApplication from './Components/Clients/ClientApplication';
import ClientDocuments from './Components/Clients/ClientDocuments';
import MatchingLenders from './Components/Clients/MatchingLenders';
import HomePage from './Components/Public/HomePage';
import LenderOffers from './Components/Clients/LenderOffers';
import ApplicationLenderOffers from './Components/Admin/ApplicationLenderOffers';
import RejectApplication from './Components/Public/RejectApplication';
import ApproveApplication from './Components/Public/ApproveApplication';
import ViewLendingApplication from './Components/Admin/ViewLendingApplication';
import LendingApplicationsReports from './Components/Admin/Report';
import Subscription from './Components/Master/Subscription';
import CreditPricing from './Components/Master/CreditPricing';
import CreditUsagePrice from './Components/Master/CreditUsagePrice';
import State from './Components/Master/State';
import ClientDashboard from './Components/Clients/ClientDashboard';
import ClientApplications from './Components/Clients/ClientApplications';
import UserCredits from './Components/Clients/UserCredits';
import ClientPlans from './Components/Clients/ClientPlans';
import ApproveLenders from './Components/Reports/ApproveLenders';
import ClientLenders from './Components/Clients/ClientLenders';
import SubscriptionsReport from './Components/Reports/SubscriptionsReport';
import PaymentReport from './Components/Reports/PaymentReport';
import ClientsReport from './Components/Reports/ClientsReport';
import RejectedLenders from './Components/Reports/RejectedLenders';
import LenderRankings from './Components/Reports/LenderRankings';
import Pricing from './Components/Master/Pricing';
import ClientPhoneNumbers from './Components/Clients/ClientPhoneNumber';
import ClientSubscriptions from './Components/Clients/ClientSubscriptions';
import ClientPricing from './Components/Clients/ClientPricing';
import ClientSettings from './Components/Clients/ClientSettings';
import ClientLendingApplicationView from './Components/Clients/ClientLendingApplicationView';
import Profile from './Components/Admin/Profile';
import StatusReport from './Components/Reports/StatusReport';
import HeroSection from './Components/Admin/HeroSection';
import AboutSection from './Components/Admin/AboutSection';
import CardSection from './Components/Admin/CardSection';
import ServiceSection from './Components/Admin/ServiceSection';
import FooterSection from './Components/Admin/FooterSection';
import LandingPage from './Components/Admin/LandingPage';
import Leads from './Components/Admin/Leads';
import Clients from './Components/Admin/Clients';
import ClientUsers from './Components/Clients/ClientUsers';
import BrokerDashboard from './Components/Brokers/BrokerDashboard';
import BrokerApplications from './Components/Brokers/BorkerApplications';
import ChangeSubscription from './Components/Master/ChangeSubscription';
import PurchaseFunder from './Components/Clients/PurchaseFunder';
import Forgot from './Authentication/Forgot';
import ResetPassword from './Authentication/ResetPassword';
import UserTemplates from './Components/Clients/UserTemplates';

function App() {
  return (
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register/subscription/:clientId?" element={<RegisterSubscription />} />
        <Route path="/forgotpassword" element={<Forgot />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/lenders" element={<Lenders />} />
        <Route path="/industries" element={<Industry />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/lendingapplications/:status?" element={<LendingApplications />} />
        <Route path="/lendingapplication/:lendingApplicationId" element={<LendingApplication/>}/>
        <Route path="/viewlendingapplication/:lendingApplicationId" element={<ViewLendingApplication/>}/>
        <Route path="/lendingapplication/offers/:lendingApplicationId" element={<ApplicationLenderOffers/>}/>
        <Route path="/declineapplication" element={<RejectApplication/>}/>
        <Route path="/approveapplication" element={<ApproveApplication/>}/>
        <Route path="/userdashboard" element={<ClientDashboard />} />
        <Route path="/userdashboard/applications/:status?" element={<ClientApplications />} />
        <Route path="/userdashboard/upload" element={<UploadApplication />} />
        <Route path="/userdashboard/application/:lendingApplicationId" element={<ClientApplication />} />
        <Route path="/userdashboard/viewlendingapplication/:lendingApplicationId" element={<ClientLendingApplicationView/>}/>
        <Route path="/userdashboard/documents/:lendingApplicationId" element={<ClientDocuments />} />
        <Route path="/userdashboard/lenders/:lendingApplicationId" element={<MatchingLenders />} />
        <Route path="/userdashboard/offers/:lendingApplicationId" element={<LenderOffers />} />
        <Route path="/userdashboard/usercredits" element={<UserCredits />} />
        <Route path="/userdashboard/plans" element={<ClientPlans />} />
        <Route path="/userdashboard/phonenumbers" element={<ClientPhoneNumbers />} />
        <Route path="/userdashboard/mylenders" element={<ClientLenders />} />
        <Route path="/userdashboard/subscriptions" element={<ClientSubscriptions />} />
        <Route path="/userdashboard/pricing" element={<ClientPricing />} />
        <Route path="/userdashboard/profile" element={<ClientSettings />} />
        <Route path="/userdashboard/brokers" element={<ClientUsers />} />
        <Route path="/userdashboard/add-ons" element={<PurchaseFunder />} />
        <Route path="/userdashboard/templates" element={<UserTemplates />} />
        <Route path="/applications/approved" element={<ApproveLenders />} />
        <Route path="/applications/rejected" element={<RejectedLenders />} />
        <Route path="/lenders/rankings" element={<LenderRankings />} />
        <Route path="/subscription/change/:clientId" element={<ChangeSubscription />} />

        <Route path="/broker/dashboard" element={<BrokerDashboard />} />
        <Route path="/broker/applications" element={<BrokerApplications />} />

        <Route path="/report/subscriptions" element={<SubscriptionsReport />} />
        <Route path="/report/payments" element={<PaymentReport />} />
        <Route path="/report/clients" element={<ClientsReport />} />

        <Route path="/changepassword" element={<ChangePassword />} />
        <Route path="/subscriptions" element={<Subscription />} />
        <Route path="/creditpricing" element={<CreditPricing />} />
        <Route path="/creditusagepricing" element={<CreditUsagePrice />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/states" element={<State />} />
        <Route path="/lareport/:status?" element={<LendingApplicationsReports />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/statusReport" element={<StatusReport />} />
        <Route path="/heroSection" element={<HeroSection />} />
        <Route path="/aboutSection" element={<AboutSection />} />
        <Route path="/cardSection" element={<CardSection />} />
        <Route path="/serviceSection" element={<ServiceSection />} />
        <Route path="/footerSection" element={<FooterSection />} />
        <Route path="/landingpage" element={<LandingPage />} />
      </Routes>
  );
}

export default App;
